// extracted by mini-css-extract-plugin
export default {"section":"Ax-z","inSectionButton":"Bx-z","addressCard":"Cx-z","disabled":"Dx-z","cautionBox":"Ex-z","failureBox":"Fx-z","fade-out":"Gx-z","successBox":"Hx-z"};